// Include version 1.0.0.0
window.activeTippy;
let selectedPartId;

const getHotspot = (hotspotid) => {
  const strId = "hotspot." + hotspotid;
  return document.getElementById(strId);
};

function ShowHotSpot(evt, hotspotid) {
  const hotspot = getHotspot(hotspotid);
  if (hotspot) {
    hotspot.classList.add("hotspot-active");
  }
  try {
    if (
      evt.target &&
      evt.target.parentNode &&
      evt.target.parentNode.parentNode
    ) {
      selectedPartId =
        evt.target.parentNode.parentNode.getAttribute("itemnumber") ?? hotspotid;
    } else {
      selectedPartId = hotspotid;
    }

    if (window.selectedData && selectedData.piece) {
      const _selectedData = Array.isArray(selectedData.piece) ? selectedData.piece.filter(
        (e) => e.id == selectedPartId
      ) : [selectedData.piece];

        const { numident } = _selectedData[0];
        hoverCurrentPageNumber$.next(numident);
        return;
    }
  }
  catch (error) {
    console.error(error);
  }
  hoverCurrentPageNumber$.next(hotspotid);


}

function HideHotSpot(evt, hotspotid) {
  const hotspot = getHotspot(hotspotid);
  hotspot.classList.remove("hotspot-active");

  const toolTip = document.getElementById("ToolTip");
  if (toolTip) toolTip.classList.remove("tooltip-active");
  if (window.activeTippy) {
    window.activeTippy.destroy();
    window.activeTippy = null;
  }
  hoverCurrentPageNumber$.next(null);
}

function ShowToolTip(evt, hotspotid, strTooltip) {
  // in some cases, hotspotid is an hostspot id, in other cases, it is a piece id (both ids not always match)

  const hotspotElement = document.getElementById(`hotspot.${hotspotid}`);

  if (hotspotElement) {
    // this will be used by basket to get piece reference
    hotspotElement.setAttribute("strTooltip", strTooltip || '');
  }

  try {
    if (
      evt.target &&
      evt.target.parentNode &&
      evt.target.parentNode.parentNode
    ) {
      selectedPartId =
        evt.target.parentNode.parentNode.getAttribute("itemnumber") ?? hotspotid;
    } else {
      selectedPartId = hotspotid;
    }
    let _content = "";
    if (window.selectedData && selectedData.piece) {
      const _selectedData = Array.isArray(selectedData.piece) ? selectedData.piece.filter(
        (e) => e.id == selectedPartId
      ) : [selectedData.piece];
      if (_selectedData.length === 1) {
        const { id, numident, numbobst } = _selectedData[0];

        if (strTooltip) {
          _content += strTooltip;
          _content += "<hr />";
        }
        _content += `<table>
        <tr>
          <th>ID</th>
          <th>NumIdent</th>
          <th>NumBobst</th>
        </tr>
        <tr>
          <td><small>${id}</small></td>
          <td><small>${numident}</small></td>
          <td><small>${numbobst}</small></td>
        </tr>
      </table>`;
      } else if (_selectedData.length > 1) {
        const { id, numident, numbobst } = _selectedData[0];
        let machineValidity = this.getMachineValidity();

        if (strTooltip) {
          _content += strTooltip;
          _content += "<hr />";
        }
        _content += `<table>
        <tr>
          <th>ID</th>
          <th>NumIdent</th>
          <th>NumBobst</th>
          <th>Validity</th>
        </tr>`;
        _selectedData.forEach((piece) => {
          if (isPieceValid(piece, machineValidity)) {
            _content += `<tr>
              <td><small><u>${piece.id}</u></small></td>
              <td><small><u>${piece.numident}</u></small></td>
              <td><small><u>${piece.numbobst}</u></small></td>
              <td><small>&nbsp;&nbsp;<u>${piece.val}</u></small></td>
            </tr>`;
          } else {
            _content += `<tr>
              <td><small>${piece.id}</small></td>
              <td><small>${piece.numident}</small></td>
              <td><small>${piece.numbobst}</small></td>
              <td><small>&nbsp;&nbsp;${piece.val}</small></td>
            </tr>`;
          }
        });
        _content += `</table>`;
      }

    }
    if (window.activeTippy) return;
    window.activeTippy = tippy(evt.path ? evt.path[0] : evt.target, {
      allowHTML: true,
      content: _content || strTooltip,
    });
    window.activeTippy.show();
  } catch (error) {
    console.error(error);
  }
}

function OnLoadEvent() { }

window.ShowToolTip = ShowToolTip;

var newversion;
if (window.XMLHttpRequest) {
  //document.write("----- code for IE7+, Firefox, Chrome, Opera, Safari ----");
  newversion = true;
} else {
  //document.write("----- code for IE6, IE5 ----");
  newversion = false;
}
var Browser = {
  Version: function () {
    var version = 999; // we assume a sane browser
    if (navigator.appVersion.indexOf("MSIE") != -1)
      // bah, IE again, lets downgrade version number
      version = parseFloat(navigator.appVersion.split("MSIE")[1]);
    return version;
  },
};
var VersionIE = Browser.Version();
if (VersionIE != 999) {
  if (VersionIE >= 7) {
    //code for IE7, IE8
    newversion = false;
  }
}

function viewPart(selectedPartId) {
  window.routerSubject.next({ selectedPartId });
}

function viewDrawing(ident) {
  window.routerSubject.next({ ident });
}

parent.vue_piece = (piece) => {
  window.routerSubject.next({ selectedPartId: piece ?? selectedPartId });
};

parent.vue_plan = (ident) => {
  window.routerSubject.next({ ident });
};

function isPieceValid(piece, machineValidity) {
  if (!piece || !piece.val) {
    return false;
  }
  var minMax = piece.val.split('/');
  if (minMax.length === 1 || !minMax[1].trim()) {
    return machineValidity >= Number(minMax[0]);
  } else if (minMax.length === 2) {
    return machineValidity >= Number(minMax[0]) && machineValidity <= Number(minMax[1]);
  } else {
    return false;
  }
}

function getMachineValidity() {
  return window['machineSerial'] && window['machineSerial'].length === 12 ?
    Number(window['machineSerial'].slice(7, 10)) : 0;
}
